<template>
  <section style="position:relative" id="section">

    <el-row class="statusRow">
    
      <el-button size="medium" type="primary" @click="addProduct">新增</el-button>
      <el-button size="medium" type="success" @click="changeStatus(false,1)">启用</el-button>
      <el-button size="medium" type="danger" @click="changeStatus(false,0)">禁用</el-button>
   <!--   <el-button size="medium" type="info" @click="changeStatus(false,-1)">删除</el-button>-->
		
     
		 
    </el-row>
    <!--列表-->
    <el-table
      :data="plist"
      style="width: 100%;min-width:1200px"
      stripe
      row-key="id"
      @selection-change="select"
      class="demo-table"
    >
     <el-table-column type="selection" min-width="30px"></el-table-column>
     <el-table-column prop="id" fixed label="ID" min-width="50px" width="50" align="center"></el-table-column>
     <el-table-column prop="name" fixed label="小游戏名称" min-width="50px" align="center" >

     			<template slot-scope="scope">
			<!--		      <el-button size="medium" type="danger" @click="deleteProduce(true,scope.row)">删除</el-button>-->
					      <el-button size="medium" type="text"   @click="$router.push({name:'扣量规则详情',params:{index_id:scope.row.id}})">{{scope.row.name}}</el-button>
     		 </template>
     </el-table-column>
     <el-table-column prop="pr" fixed label="扣量比例" min-width="50px" align="center"  ></el-table-column>
     <el-table-column prop="ald_key" fixed label="原始阿拉丁key" min-width="50px" align="center"></el-table-column>

     





     <el-table-column prop="status" fixed label="激活状态" min-width="50px" width="150"  align="center">
     	<template slot-scope="scope">
          <el-button
            size="mini"
            :type="scope.row.status=='1'?'success':'danger'"
            @click="changeStatus(true,scope.row)"
          >{{scope.row.status=='1'?'正常':'禁用'}}</el-button>
        </template>
     </el-table-column>
     <el-table-column prop="status" fixed label="操作" min-width="50px" width="150"  align="center">
     		 <template slot-scope="scope">
			<!--		      <el-button size="medium" type="danger" @click="deleteProduce(true,scope.row)">删除</el-button>-->
					      <el-button size="medium" type="primary" @click="editRule(scope.row)">编辑</el-button>
     		 </template>
     </el-table-column>
     
    
    </el-table>
   

    <div class="pageRow">
      <el-pagination
        class="pagination"
        @size-change="SizeChange"
        @current-change="CurrentChange"
        :current-page.sync="pdata.page"
        :page-sizes="[20, 40, 60, 80]"
        :page-size="pdata.perpage"
        background
        layout="sizes, prev, pager, next, jumper"
        :total="pdata.perpage*maxPage"
      ></el-pagination>
    </div>

    <el-dialog
      :title="isAdd?'添加屏蔽规则':'编辑屏蔽规则'"
      :visible.sync="editDialog"
      top="5vh"
      width="1000px"
      custom-class="dialog"
      :close-on-click-modal="false"
    >
      <el-form :model="chooseProduct" :rules="rules" ref="ruleForm" :label-width="formLabelWidth">
      	<el-form-item label="小程序选择" prop="issued_app_id">
          <searchApp
            @getid="res=>{chooseProduct.issued_app_id=res}"
            compare="name"
            :pholder="chooseProduct.issued_app_id"
          ></searchApp>
        </el-form-item>
        <el-row :gutter="5" style="margin:0;">
        	<el-col :span="8">
        		<el-form-item label="默认扣量"> <el-input v-model="chooseProduct.pr" placeholder="请输入扣量"></el-input></el-form-item>
        	</el-col>
        	<el-col :span="2">
        		<span>&nbsp;</span>
        	</el-col>
        	<el-col :span="12">
        		<el-form-item label="原始ALDKEY"> <el-input v-model="chooseProduct.ald_key" placeholder="请输入key"></el-input></el-form-item>
        	</el-col>
        	
        </el-row>

<!--      	
      	
      
      	
      
			  
			 

        <el-form-item label="扣量规则" v-for="(item,index) in chooseProduct.rule" prop="rule">

        	<el-row  :gutter="5" style="margin:0;">
        		 <el-col :span="4"><div class="grid-content bg-purple-light"><el-input v-model="item.channel" placeholder="渠道名称"></el-input></div></el-col>
        		 <el-col :span="3"><div class="grid-content bg-purple-light"><el-input v-model="item.pr" placeholder="扣量比例"></el-input></div></el-col>
        		 <el-col :span="3"><div class="grid-content bg-purple-light"><el-input v-model="item.media_o" placeholder="扣量mieia_id"></el-input></div></el-col>
        		 <el-col :span="5"><div class="grid-content bg-purple-light"><el-input v-model="item.link_o" placeholder="扣量link_id"></el-input></div></el-col>
        		 <el-col :span="3"><div class="grid-content bg-purple-light"><el-input v-model="item.media" placeholder="原始mieia_id"></el-input></div></el-col>
        		 <el-col :span="5"><div class="grid-content bg-purple-light"><el-input v-model="item.link" placeholder="原始link_id"></el-input></div></el-col>
        	
        		 	<el-col :span="2">
						 		<div class="grid-content bg-purple-light" style="font-size: 24px; cursor: pointer;"> <i class="el-icon-circle-plus"  @click="addRules"></i> <i class="el-icon-remove" v-if="chooseProduct.rule.length>1"  @click="removeRules(index)"></i> </div>
						  </el-col>
        	</el-row>
        </el-form-item>-->
        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="更新日志" :visible.sync="logDialog">
      <el-table :data="plog">
        <el-table-column prop="username" label="操作人员" width="150"></el-table-column>
        <el-table-column prop="create_time" label="更新时间" width="200"></el-table-column>
        <el-table-column prop="content" label="备忘"></el-table-column>
      </el-table>
    </el-dialog>
  </section>
</template>

<script>
import { rulesAldList, rulesAldAdd, aldStatus, splog, rulesAldEdit } from "../../api/api";
//import UploadImg from "./uploadImg.vue";

export default {
  components: {
//  UploadImg
  },
  data() {
    return {
      rules: {
        issued_app_id: [{ required: true, message: "请输入产品名称", trigger: "blur" }],
      },
      isFy: false,
      fy: { name: "ces" },
      pdata: {
        page: 1,
        perpage: 20,
        issued_app_name:"",
        theme: "",
        status: "",
        kw: "",
        sort_field: "",
        sort_by: "",
        placement:""
      },
      plist: [],
      maxPage: 1,
      config: [],
      tags: [],
      editDialog: false,
      formLabelWidth: "100px",
      chooseTags: [],
      plog: [], //日志
      logDialog: false,

      sText: "请选择产品状态",
      tText: "请选择产品题材",
      pText:"请选择产品投放位置",
      imageUrl: "",

      headMsg: {
        token: ""
      },
      imageUrl: "",
      isAdd: false,
      cP: {
        index_id: "",
        status: "1",
        log: ""
      }, //修改选中的产品状态,批量修改状态
      selectProduct: [], //批量修改选中的产品
      prWidth: 0,
      option: [], //投放位置配置
      chooseProduct: {
      "issued_app_id": "",
//    "rule": [{"channel":"", "pr":"","media_o":"","link_o":"","media":"","link":""}],
      "pr":"", 
			"ald_key":""
			},
      gnTxt:{
      	no:'',
      	city:'',
      	scene_black:'',
      	scene_white:'',
      	show:false,
      	left:0,
      	top:0,
      }
    };
  },
  watch: {

  },
  methods: {
//	addRules(){
//		var o={pr:"",media_o:"",link_o:"",media:"",link:""};
//		this.chooseProduct.rule.push(o);
//	},
//	removeRules(i){
//		this.chooseProduct.rule.splice(i,1); 
//	},
    getList() {
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      rulesAldList(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.plist = res.data.list;
          this.maxPage = res.data.max_page;
        }
      });
    },
    getConfig() {
      if (this.$store.config) {
        this.config = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
        this.option = this.$store.config.product_placement;
      } else {
        setTimeout(() => {
          this.getConfig();
        }, 50);
      }
    },
    statueFilter(s) {
      this.sText = s == "" ? "请选择产品状态" : s == "0" ? "禁用" : "启用";
      this.pdata.status = s;
      this.getList();
    },
    themeFilter(s) {
      this.tText = s == "" ? "请选择产品题材" : s;
      this.pdata.theme = s;
      this.getList();
    },
    placementFilter(s){
    	this.pText = s == "" ? "请选择产品投放位置" : s;
    	this.pdata.placement = s;
    	this.getList();
    },
    search() {
      // this.$refs.input.blur();
      this.getList();
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    editRule(d) {
      this.editDialog = true;
      this.chooseProduct = JSON.parse(JSON.stringify(d));
      this.chooseProduct.index_id=d.id;
      delete this.chooseProduct.create_time;
      this.isAdd = false;
    },
    changeStatus(isSingle, s) {
      if (!isSingle && this.selectProduct.length == 0) {
        this.$message.error("请先选择需要批量操作的数据");
        return;
      }
      if (isSingle) {
        this.cP.index_id = s.id;
        this.cP.status = s.status == 1 ? "0" : "1";
      } else {
        this.cP.status = s;
      }

      if (this.cP.status == 0) {
        this.cP.log = "禁用产品";
      } else if (this.cP.status == 1) {
        this.cP.log = "启用产品";
      } else if (this.cP.status == -1) {
        this.cP.log = "删除产品";
      }
      aldStatus(this.cP, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.getList();
          this.$message({ message: this.cP.log + "成功", type: "success" });
        }
      });
    },
    deleteProduce(isSingle,s){
    	if (isSingle) {
        this.cP.index_id = s.id;
        this.cP.status ='-1';
      }
    	 ruleStatus(this.cP, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.getList();
          this.$message({ message: this.cP.log + "成功", type: "success" });
        }
      });
    	
    },
    addProduct() {
    	this.chooseProduct={
      "issued_app_id": "",
//    "rule": [{"channel":"", "pr":"","media_o":"","link_o":"","media":"","link":""}],
      "pr":"", 
			"ald_key":""
			};
      this.editDialog = true;
      this.isAdd = true;
    },
    submit() {
    	
    	var rule=this.chooseProduct.rule;
//			for(let i=0;i<this.chooseProduct.rule.length;i++){
//			  if(this.chooseProduct.rule[i].pr==''||this.chooseProduct.rule[i].media_o==''||this.chooseProduct.rule[i].link_o==''||this.chooseProduct.rule[i].media==''||this.chooseProduct.rule[i].link==''){
//			  	 this.$message.error("扣量规则不能为空");
//			     return false
//			  }
//			}

			
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.isAdd) {
          	
          	
          	var p ={
          		"issued_app_id":this.chooseProduct.issued_app_id,
  		     		"pr":this.chooseProduct.pr,
							"ald_key":this.chooseProduct.ald_key,
//        		"rule":encodeURIComponent(JSON.stringify(rule)),
          	}
            rulesAldAdd(p, this.$cookie.getCookie("login")).then(
              res => {
                if (res.code == 200) {
                	this.$message({
					          message: '添加成功',
					          type: 'success'
					        });
                  this.getList();
                  this.editDialog = false;
                } else {
                  this.$message.error(res.msg);
                }
              }
            );
          } else {
//          this.$prompt("请输入编辑原因", "提示", {
//            confirmButtonText: "确定",
//            cancelButtonText: "取消",
//            inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
//            inputErrorMessage: "内容不能为空"
//          }).then(({ value }) => {
              //this.chooseProduct.log = value;
              	var p ={
		          		"issued_app_id":this.chooseProduct.issued_app_id,
		          		"pr":this.chooseProduct.pr,
									"ald_key":this.chooseProduct.ald_key,
//		          		"rule":encodeURIComponent(JSON.stringify(this.chooseProduct.rule)),
		          		"index_id":this.chooseProduct.index_id,
		          	}
              rulesAldEdit(p, this.$cookie.getCookie("login")).then(
                res => {
                  if (res.code == 200) {
                    this.getList();
                    this.editDialog = false;
                  } else {
                    this.$message.error(res.msg);
                  }
                }
              );
//          });
          }
        } else {
          return false;
        }
      });
    },
    select(s) {
      this.selectProduct = s;
      var p = "测";
      s.forEach((v, i) => {
        p += "," + v.id;
      });
      this.cP.index_id = p.slice(2);
    },
    openDealy(id) {
      splog(id, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.logDialog = true;
          this.plog = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    getInfo(s) {
      this.chooseProduct = JSON.parse(JSON.stringify(s));
      delete this.chooseProduct.id;
      this.chooseProduct.path='';
      this.chooseProduct.placement=''
      this.chooseProduct.log = "新增复用产品";
      this.chooseTags = this.chooseProduct.tags.split(",");
    }
  },
  created() {
    let that = this;
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13 && that.editDialog) {
        that.submit();
        return false;
      }
    };
  },
  mounted() {
    this.getList();
    this.getConfig();
    this.headMsg.token = this.$cookie.getCookie("login");
    this.prWidth = document.getElementById("section").offsetWidth;
  }
};
</script>
<style scoped lang="scss">
span.gn{
	color: #20A0FF;
	cursor: pointer;
}
.dialog {
  width: 800px;
}
.size {
  width: 100px;
  text-align: right;
  position: absolute;
  top: 20px;
  left: -100px;
  padding-right: 14px;
  box-sizing: border-box;
  color: #999;
  font-size: 12px;
}
</style>

<style >
.demo-table .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    min-width: 200px;
    padding: 0 25px;
}
.demo-table .demo-table-expand label {

    color: #99a9bf;
}
.el-form--inline .el-form-item__content {
    display: inline-block;
    vertical-align: top;
}
.el-upload-list__item {
  line-height: 0;
}
.selectRow {
  min-width:1200px;padding:15px;background: #fff;
}
.statusRow {
  background: #f2f6fc;
  padding: 15px;
  box-sizing: border-box;
  border-left: 4px solid #409eff;
  min-width: 600px;
}
.statusRow > .el-button {
  margin-right: 6px;
}
.gameIcon {
  width: 60px;
  height: 60px;
  border-radius: 6px;
}
.dropdown {
  min-width: 120px;
  width: 170px;
}
.dropdown-menu {
  width: 170px;
  margin: 0 auto;
  text-align: center;
}
.search,
.input {
  width: 220px;
}
.inline {
  display: inline-block;
  vertical-align: top;
}
.pageRow {
  min-width: 1200px;
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: sticky;
  left: 0;
  bottom: -20px;
  z-index: 1000;
}
@media only screen and (max-width: 767px) {
  .phoneHide {
    display: none;
  }
  .search {
    width: 60px;
  }
  .selectRow {
    min-width: 300px;
    padding: 5px;
  }
  .dropdown {
    width: 100%;
  }
  .dropdown-menu {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// ALDlist.vue?6be7b080